// Given a decimal value, returns a float between 0 and 1
export function getDecibelToLinear(dB: number): number {
    const linear = Math.pow(10, dB / 20);

    return linear;
}

// Given a float between 0 and 1, return a decimal value
export function getLinearToDecibel(linear: number): number {
    // Fallback to 0db if we got invalid linear value
    const db = linear >= 0 ? 20 * Math.log10(linear) : 0;

    return db;
}
